import { Injectable } from '@angular/core';
import { ActivitiesAggrigatorModel } from '@shared/model/activities-aggrigator-model';
import { ActivityVerbEnum } from '@shared/model/enum/activity-verb-enum';
import { INotifTextStrategy } from '../model/notification.model';

@Injectable({
  providedIn: 'root'
})
export class RequestNotifStrategy implements INotifTextStrategy {

  public createText(
    activity: ActivitiesAggrigatorModel,
  ): string {
    const verb = activity?.verb;

    switch (verb) {
      case ActivityVerbEnum.bloggerAccept:
        return `درخواست بلاگری شما تایید شد.`;

      case ActivityVerbEnum.LibrarianAccept:
        return `درخواست کتابداری شما تایید شد.`;

      case ActivityVerbEnum.BookRequestAccepted:
        return `کتاب درخواستی شما افزوده شد.`;


      default:
        return '';
    }
  }
}